import type { FormEvent } from 'react';
import { Button } from '@/components/Button';
import { Form } from '@/components/Form';
import { TextField } from '@/components/TextField';
import { EMAIL_PATTERN } from '@/constants';
import { useDataLayer } from '@/hooks/useDataLayer';

interface NewsletterFormProps {
  handleSubmit: (e: FormEvent<HTMLFormElement>) => void;
  hasError: boolean;
  isPending: boolean;
}

export const NewsletterForm = ({
  handleSubmit,
  hasError,
  isPending,
}: NewsletterFormProps) => {
  const { formInteract } = useDataLayer();

  return (
    <Form handleSubmit={handleSubmit} orientation="inline" withLabels={true}>
      <TextField
        isRequired
        // Only assert isInvalid for the server-rejection case. A *defined* isInvalid is a
        // controlled validation state in react-stately - displayValidation resolves as
        // `controlledError || serverError || currentValidity`, so a literal `false` pinned the
        // field valid and FieldError bailed out before native validity was consulted. The browser
        // still blocked the submit and react-aria still preventDefaulted its bubble, so an invalid
        // address produced no feedback at all (#2922). Undefined hands the field back to native
        // validation; errorMessage supplies our copy in place of the browser default.
        isInvalid={hasError || undefined}
        errorMessage="Please check your email address and try again"
        // `pattern` has to travel via inputProps: TextField consumes a `pattern` prop for its ASCII
        // validation check and never forwards it to the <input>. EMAIL_PATTERN is the shared
        // front-end mirror of Easons.Core EmailValidation, so this field cannot drift from the
        // server rule the way the old inline copy did (#2922).
        inputProps={{
          autoComplete: 'email',
          pattern: EMAIL_PATTERN,
          type: 'email',
        }}
        label="Email"
        name="newsletterEmail"
        onBlur={() => formInteract('newsletter', 'email', 'complete')}
        type="email"
        width={280}
      />
      <Button isPending={isPending} type="submit">
        Subscribe
      </Button>
    </Form>
  );
};;
